import { locale } from '../services/translator';
import { webServiceHost } from '../services/dior';

export const DATA_CDC_URLS = {
  development: `/fixtures/data-cdc.json`,
  test: `/fixtures/data-cdc.json`,
  preProduction: `${webServiceHost}/couture/${locale}/ws/tools`,
  production: `${webServiceHost}/couture/${locale}/ws/tools`
};

export const DATA_PDC_URLS = {
  development: `/fixtures/data-pcd.json`,
  test: `/fixtures/data-pcd.json`,
  preProduction: `${webServiceHost}/beauty/${locale}/api/v2/menu/all.json`,
  production: `${webServiceHost}/beauty/${locale}/api/v2/menu/all.json`
};

export const GTM_COM_KEY = 'GTM-5NT5ZL8';
export const GTM_CN_KEY = 'GTM-PN3F34N';
export const GTM_SCRIPT = '//www.googletagmanager.com/gtm.js';
export const GTM_PAGE_TYPE = 'DiorCom_OneDior_StoreLocator';

export const INTEGRATION_MODE_QUERY_PARAMETER = 'mode';



// WEBPACK FOOTER //
// ./src/settings/shared.js